import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'

import PropTypes from 'prop-types'
import get from 'lodash/get'

import SampleActivity from './SampleActivity'
import ActivityCard from './ActivityCard'
import { NotificationManager } from 'react-notifications'

import sampleActivitiesData from './SampleActivitiesData'

import GET_USER from './../../graphql/User.graphql'
import { GET_USER_LOCAL_TOURS, DELETE_LOCAL_TOUR } from './../../graphql/ActivityList'

class ActivityList extends Component {
  static propTypes = {
    history: PropTypes.object,
    userQuery: PropTypes.object,
    localToursQuery: PropTypes.object,
    deleteLocalTour: PropTypes.func,
    t: PropTypes.func
  }

  componentWillReceiveProps(next) {
    if (!next.userQuery.loading && !next.userQuery.user) {
      this.props.history.push('/')
    }
  }

  async onTourDelete(id) {
    try {
      await this.props.deleteLocalTour({
        variables: { id }
      })

      await this.props.localToursQuery.refetch()
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
      console.warn(err)
    }
  }

  renderActivityCards() {
    if (this.props.localToursQuery.loading) return null

    if (Array.isArray(this.props.localToursQuery.allLocalTours) && this.props.localToursQuery.allLocalTours.length) {
      return this.props.localToursQuery.allLocalTours.map(tour => {
        return (
          <ActivityCard
            key={tour.id}
            data={tour}
            onEditClick={id => {
              this.props.history.push(`/activity-steps/${id}/title-tags`)
            }}
            onPreviewClick={id => {
              this.props.history.push(`/activity/${id}`)
            }}
            onDeleteClick={id => this.onTourDelete(id)}
          />
        )
      })
    }

    return null
  }

  renderSampleActivities() {
    if (!this.props.localToursQuery.loading) {
      if (Array.isArray(this.props.localToursQuery.allLocalTours) && this.props.localToursQuery.allLocalTours.length) {
        return null
      }
    }

    return (
      <div className="activity-list__sample-activities">
        <div className="heading">
          <h3>{this.props.t('sample_activities')}</h3>
        </div>
        <div className="sample-activities">
          {sampleActivitiesData.map((item, index) => {
            return <SampleActivity key={index} {...item} />
          })}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="site-container activity-list">
        <div className="jumbotron-wrapper">
          <div className="jumbotron container text-center">
            <h1>{this.props.t('title')}</h1>
            <h3>{this.props.t('slogan')}</h3>
            <button
              className="activity-list__create-activity-btn btn btn-danger"
              onClick={() => {
                this.props.history.push('/activity-steps/title-tags')
              }}
            >
              {this.props.t('create_activity')}
            </button>
          </div>
        </div>
        {this.renderSampleActivities()}
        <div className="activity-list__activities container">
          <div className="col-md-10 col-md-offset-1">
            <div className="clearfix" style={{ marginBottom: '20px' }}>
              <button
                className="activity-list__create-activity-btn pull-right btn btn-danger"
                onClick={() => {
                  this.props.history.push('/activity-steps/title-tags')
                }}
              >
                {this.props.t('add_activity')}
              </button>
            </div>
            {this.renderActivityCards()}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  translate('activity_list'),
  graphql(GET_USER, {
    name: 'userQuery'
  }),
  graphql(GET_USER_LOCAL_TOURS, {
    name: 'localToursQuery',
    options: props => ({
      variables: {
        tripGuideId: get(props, 'userQuery.user.id', '')
      }
    })
  }),
  graphql(DELETE_LOCAL_TOUR, {
    name: 'deleteLocalTour'
  })
)(ActivityList)



// WEBPACK FOOTER //
// src/components/ActivityList/index.js